// Employee scope helpers — regola UNICA di cessazione (Fase 2 · v0.99.29).
// Riflette la stessa logica del backend `services/employee_scope.py`.
//
// REGOLA: un dipendente è ATTIVO in un periodo se:
//   cessation_date IS NULL OR cessation_date >= start_period_iso
// → Cessato il 30/06 compare in tutte le elaborazioni fino a giugno incluso,
//   escluso dal 01/07 in avanti.
import { formatDateIT } from "@/foundation/formatting";

/**
 * Il dipendente è attivo alla data `refIso` (YYYY-MM-DD)?
 */
export function isActiveAt(emp, refIso) {
  if (!emp) return false;
  if (emp.hire_date && emp.hire_date > refIso) return false;
  if (!emp.cessation_date) return true;
  return emp.cessation_date >= refIso;
}

/**
 * Il dipendente è attivo in almeno un giorno del mese [year, month]?
 * (Regola: cessation_date IS NULL OR cessation_date >= YYYY-MM-01)
 */
export function isActiveInMonth(emp, year, month) {
  if (!emp) return false;
  const startIso = `${year}-${String(month).padStart(2, "0")}-01`;
  const lastDay = new Date(year, month, 0).getDate();
  const endIso = `${year}-${String(month).padStart(2, "0")}-${String(lastDay).padStart(2, "0")}`;
  if (emp.hire_date && emp.hire_date > endIso) return false;
  if (!emp.cessation_date) return true;
  return emp.cessation_date >= startIso;
}

/**
 * Il dipendente è attivo in almeno un giorno dell'anno?
 */
export function isActiveInYear(emp, year) {
  if (!emp) return false;
  if (emp.hire_date && emp.hire_date > `${year}-12-31`) return false;
  if (!emp.cessation_date) return true;
  return emp.cessation_date >= `${year}-01-01`;
}

/**
 * Filtra la lista dipendenti attivi nel mese richiesto.
 */
export function filterActiveInMonth(employees, year, month) {
  return (employees || []).filter((e) => isActiveInMonth(e, year, month));
}

/**
 * Filtra la lista dipendenti attivi nell'anno richiesto.
 */
export function filterActiveInYear(employees, year) {
  return (employees || []).filter((e) => isActiveInYear(e, year));
}

/** Format ISO YYYY-MM-DD → DD/MM/YYYY (o stringa vuota).
 * @deprecated Usare direttamente `formatDateIT` da `@/foundation/formatting`.
 * Wrapper conservato solo per retro-compatibilita' dei chiamanti storici;
 * verra' rimosso nella prossima major release. Non aggiungere nuovi consumer.
 */
export function fmtCessationDate(iso) {
  if (!iso) return "";
  return formatDateIT(iso, iso);
}

/** Etichetta di stato leggibile: 'Attivo' / 'Cessato dal DD/MM/YYYY' / 'Cessazione DD/MM/YYYY'. */
export function statusLabel(emp) {
  if (!emp || !emp.cessation_date) return "Attivo";
  const today = new Date().toISOString().slice(0, 10);
  if (emp.cessation_date < today) return `Cessato dal ${fmtCessationDate(emp.cessation_date)}`;
  if (emp.cessation_date === today) return "Attivo (ultimo giorno)";
  return `Cessazione ${fmtCessationDate(emp.cessation_date)}`;
}
